export default __webpack_public_path__ + "static/cake-close-f6fe162ae1d9f69f2762c599447a6a01.png";